import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgS3Storage = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-s3-storage';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M3.131 3.399c.011.087.747 4.029 1.634 8.76l1.612 8.601h11.246l1.612-8.601c.887-4.731 1.623-8.673 1.634-8.76l.022-.159H3.109zM19.069 4.87l-1.355 7.24-1.334 7.13H7.62l-1.334-7.13-1.355-7.24-.021-.11h14.18zM10.28 8v1.76h3.48V6.24h-3.48zm-1.589 4.672L7.403 14.74l1.298.011c.715.005 1.883.005 2.598 0l1.298-.011-1.288-2.068c-.709-1.138-1.298-2.069-1.309-2.069s-.6.931-1.309 2.069m5.273-1.849c-.935.252-1.579 1.223-1.444 2.178.073.512.244.838.639 1.215a1.95 1.95 0 0 0 2.682 0c.395-.377.566-.703.639-1.215.136-.964-.513-1.933-1.461-2.18a2.45 2.45 0 0 0-1.055.002"
    })
  }));
});
export default SvgS3Storage;